<template>
  <div id="project-one-theme-gallery-view">
    <h2>ProjectOneThemeGalleryView.vue</h2>
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
#project-one-theme-gallery-view {
  background-color: darkorange;
  color: white;
  height: 100%;
}
</style>
